/**
 * 최빈개발도상국 특혜관세(세율부호 R) 안내 자료 — 문의 #141(2026-10-06).
 * 출처는 모두 국가법령정보센터 Open API 원문(2026-10-06 확인):
 *  - 최빈개발도상국에 대한 특혜관세 공여 규정 [대통령령 제35947호, 2025.12.30 공포, 2026.1.2 시행] — 제2조·제5조, 별표 1(2025.2.28 개정)·비고, 별지 원산지증명서 뒤쪽
 *  - 특혜관세 적용 및 원산지증명 제도 운영에 관한 고시 [관세청고시 제2025-62호, 2025.11.24] — 제5조(원산지증명서 제출)·제12조(직접운송 원칙)
 * 판정에 쓰지 않는다(안내). 별표 1·비고가 개정되면 이 파일을 고친다.
 */
const LAW = "https://www.law.go.kr";

export const LDC_CHECKED_AT = "2026-10-06";

export const LDC_LAWS = [
  { name: "관세법 제76조(일반특혜관세의 적용기준)", kind: "법률", url: `${LAW}/법령/관세법/제76조` },
  { name: "최빈개발도상국에 대한 특혜관세 공여 규정", kind: "대통령령 제35947호", url: `${LAW}/법령/최빈개발도상국에대한특혜관세공여규정` },
  { name: "특혜관세 적용 및 원산지증명 제도 운영에 관한 고시", kind: "관세청 고시", url: `${LAW}/행정규칙/특혜관세적용및원산지증명제도운영에관한고시` },
  { name: "원산지표시제도 운영에 관한 고시", kind: "관세청 고시", url: `${LAW}/행정규칙/원산지표시제도운영에관한고시` },
  { name: "관세법 시행령 제236조(원산지증명서의 제출 등)", kind: "대통령령", url: `${LAW}/법령/관세법시행령/제236조` },
];

/** 특혜대상 물품 및 세율(공여 규정 별표 2) — 국가법령정보센터 첨부 엑셀 */
export const LDC_ANNEX2_XLSX = "https://www.law.go.kr/BYL/grtFile/law0052462024123135127KC_000200E.xlsx";

/** 별표 1 — 특혜관세가 적용되는 최빈개발도상국(2025.2.28 개정). limited=true 는 아래 비고의 적용 기한이 있는 나라. */
export const LDC_COUNTRIES = [
  { region: "아시아", names: ["네팔*", "동티모르", "라오스*", "미얀마", "방글라데시*", "부탄*", "아프가니스탄", "예멘", "캄보디아*"] },
  { region: "오세아니아", names: ["솔로몬제도*", "키리바시", "투발루"] },
  {
    region: "아프리카",
    names: ["감비아", "기니", "기니비사우", "남수단", "니제르", "라이베리아", "레소토", "르완다", "마다가스카르", "말라위", "말리", "모리타니",
      "모잠비크", "베냉", "부룬디", "부르키나파소", "상투메프린시페*", "세네갈*", "소말리아", "수단", "시에라리온", "앙골라", "에리트레아",
      "에티오피아", "우간다", "잠비아", "중앙아프리카공화국", "지부티", "차드", "코모로", "콩고민주공화국", "탄자니아", "토고"],
  },
  { region: "아메리카", names: ["아이티"] },
];

/** 별표 1 비고 — 나라별 적용 기한(수입신고일 기준) */
export const LDC_LIMITS = [
  "네팔, 라오스 및 방글라데시: 2029년 11월 23일까지 수입신고하는 물품",
  "솔로몬제도: 2030년 12월 13일까지 수입신고하는 물품",
  "상투메프린시페: 2025년 4월 1일부터 2027년 12월 12일까지 수입신고하는 물품",
  "부탄: 2025년 4월 1일부터 2026년 12월 12일까지 수입신고하는 물품",
  "캄보디아 및 세네갈: 2032년 12월 18일까지 수입신고하는 물품",
];
